import { ReferenceInput, AutocompleteInput, FormDataConsumer, required, TextInput, maxLength } from "react-admin";

import { Typography, Grid, FormControlLabel, Checkbox } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { useEffect, useState } from "react";
import dataProvider from "server/dataProvider";
import { useFormContext } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { tenants } from "utils/tenants";
import { useNotifyError } from "utils/useNotifyError";

const AddressSection = ({ defaultBirthCountry, setBirthCountry, userData, same, setSame, isDisable, isForeigner }) => {
  const { setValue } = useFormContext();
  const notifyError = useNotifyError();
  const [residenceSettlementId, setResidenceSettlementId] = useState(userData?.residenceSettlementId);
  const [correspondenseSettlementId, setCorrespondenceSettlementId] = useState(userData?.correspondenceSettlementId);
  const isMgu = settings.tenant === tenants.MGU;

  useEffect(() => {
    if (!userData?.birthSettlementId) return;
    dataProvider
      .customRequest(administrationRequests.getSettlementById(userData?.birthSettlementId), null, "GET")
      .then(settlement => {
        setValue("birthSettlementId", settlement?.data?.id);
      })
      .catch(notifyError);
  }, [setValue, userData?.birthSettlementId, notifyError]);

  useEffect(() => {
    if (!residenceSettlementId) {
      setValue("residencePostalCode", null);
    } else {
      dataProvider
        .customRequest(administrationRequests.getSettlementById(residenceSettlementId), null, "GET")
        .then(settlement => {
          setValue("residenceSettlementId", settlement?.data?.id);
          setValue("residencePostalCode", settlement?.data?.postalCode);
        })
        .catch(notifyError);
    }
  }, [residenceSettlementId, setValue, notifyError]);

  useEffect(() => {
    if (!correspondenseSettlementId) {
      setValue("correspondencePostalCode", null);
    } else {
      dataProvider
        .customRequest(administrationRequests.getSettlementById(correspondenseSettlementId), null, "GET")
        .then(settlement => {
          setValue("correspondenceSettlementId", settlement?.data?.id);
          setValue("correspondencePostalCode", settlement?.data?.postalCode);
        })
        .catch(notifyError);
    }
  }, [correspondenseSettlementId, setValue, notifyError]);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          color={"primary"}
          fontSize={18}
        >
          Място на раждане
        </Typography>
      </Grid>
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <ReferenceInput
                reference={administrationRequests.getCountriesSelect()}
                source="birthCountryId"
              >
                <AutocompleteInput
                  defaultValue={
                    !isForeigner && !userData?.birthCountryId ? defaultBirthCountry : userData?.birthCountryId
                  }
                  filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  optionText="nameBg"
                  label="Държава"
                  validate={!isMgu && !isForeigner ? required("Задължително") : null}
                  readOnly={isDisable}
                  fullWidth
                />
              </ReferenceInput>
            </Grid>
            {formData.birthCountryId === defaultBirthCountry ? (
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  reference={administrationRequests.getSettlementsSelect()}
                  source="birthSettlementId"
                  filter={{ showDistrictAndMunicipality: true, showPostalCode: true }}
                >
                  <AutocompleteInput
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                    optionText="nameBg"
                    optionValue="id"
                    label="Населено място"
                    validate={!isMgu && !isForeigner ? required("Задължително") : null}
                    readOnly={isDisable}
                    fullWidth
                  />
                </ReferenceInput>
              </Grid>
            ) : (
              <>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <TextInput
                    label="Населено място"
                    source="birthSettlement"
                    validate={
                      isMgu || isForeigner || (formData.visadNumber && formData.visadIssuedOn)
                        ? null
                        : required("Задължително")
                    }
                  />
                </Grid>
              </>
            )}
            <Grid
              item
              md={4}
            >
              <CustomDateInput
                fullWidth
                source="birthDate"
                label="Дата на раждане"
                defaultValue={userData?.birthDate !== undefined ? userData?.birthDate : null}
                validate={!isMgu && !isForeigner ? required("Задължително") : null}
                readOnly={isDisable}
                required={!isMgu && !isForeigner}
              />
            </Grid>
            {isForeigner && formData.birthCountryId !== defaultBirthCountry ? (
              <>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <TextInput
                    label="Номер на Виза Д"
                    source="visadNumber"
                    readOnly={isDisable}
                  />
                </Grid>
                <Grid
                  item
                  md={4}
                >
                  <CustomDateInput
                    fullWidth
                    source="visadIssuedOn"
                    label="Дата на издаване на Виза Д"
                    readOnly={isDisable}
                  />
                </Grid>
              </>
            ) : null}
          </>
        )}
      </FormDataConsumer>

      {/* //Постоянен адрес (Адрес по ЛК)   +          Адрес за кореспонденция   */}
      <FormDataConsumer>
        {({ formData, scopedFormData }) => (
          <Grid
            container
            spacing={2}
            pl={3}
          >
            <Grid
              item
              xs={6}
            >
              <Grid
                container
                spacing={2}
                pr={2}
              >
                <Grid
                  item
                  xs={12}
                >
                  <Typography
                    color={"primary"}
                    fontSize={18}
                    paddingY={2}
                  >
                    Постоянен адрес (Адрес по ЛК)
                  </Typography>
                </Grid>
                <FormDataConsumer>
                  {({
                    formData, // The whole form data
                    scopedFormData, // The data for this item of the ArrayInput
                  }) => (
                    <>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                      >
                        <ReferenceInput
                          reference={administrationRequests.getCountriesSelect()}
                          source="residenceCountryId"
                        >
                          <AutocompleteInput
                            defaultValue={
                              !isForeigner
                                ? userData?.residenceCountryId || defaultBirthCountry
                                : userData?.residenceCountryId
                            }
                            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                            optionText="nameBg"
                            label="Държава"
                            validate={!isMgu && !isForeigner ? required("Задължително") : null}
                            readOnly={isDisable}
                            fullWidth
                          />
                        </ReferenceInput>
                      </Grid>
                      {formData.residenceCountryId === defaultBirthCountry ? (
                        <Grid
                          item
                          xs={12}
                          lg={6}
                        >
                          <ReferenceInput
                            reference={administrationRequests.getSettlementsSelect()}
                            source="residenceSettlementId"
                            filter={{ showDistrictAndMunicipality: true, showPostalCode: true }}
                          >
                            <AutocompleteInput
                              defaultValue={userData?.residenceSettlementId}
                              onChange={e => setResidenceSettlementId(e)}
                              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                              optionText="nameBg"
                              optionValue="id"
                              label="Населено място"
                              validate={!isForeigner && !isMgu ? required("Задължително") : null}
                              readOnly={isDisable}
                              fullWidth
                            />
                          </ReferenceInput>
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={12}
                          lg={6}
                        >
                          <TextInput
                            label="Населено място"
                            source="residenceSettlement"
                            validate={!isForeigner && !isMgu ? required("Задължително") : null}
                            defaultValue={userData?.residenceSettlement}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                </FormDataConsumer>
                {!isForeigner && (
                  <>
                    <Grid
                      item
                      xs={12}
                      lg={6}
                    >
                      <TextInput
                        source="residenceAddress"
                        label="Квартал / Улица"
                        defaultValue={userData?.residenceAddress}
                        validate={!isMgu ? required("Задължително") : null}
                        readOnly={isDisable}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={6}
                    >
                      <TextInput
                        defaultValue={userData?.residencePostalCode}
                        source={"residencePostalCode"}
                        label="Пощенски код"
                        validate={isMgu ? maxLength(10) : [required("Задължително"), maxLength(10)]}
                        readOnly={isDisable}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid
              item
              xs={6}
            >
              <Grid
                container
                spacing={2}
                pl={2}
              >
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography
                    color={"primary"}
                    fontSize={18}
                    paddingY={2}
                  >
                    {isForeigner ? "Настоящ адрес" : "Адрес за кореспонденция"}
                  </Typography>
                </Grid>
                <FormDataConsumer>
                  {({
                    formData, // The whole form data
                    scopedFormData, // The data for this item of the ArrayInput
                  }) => (
                    <>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                      >
                        <ReferenceInput
                          reference={administrationRequests.getCountriesSelect()}
                          source="correspondenceCountryId"
                        >
                          <AutocompleteInput
                            disabled={same}
                            defaultValue={
                              isForeigner
                                ? userData?.correspondenceCountryId
                                : same
                                  ? formData.residenceCountryId
                                  : userData?.correspondenceCountryId || defaultBirthCountry
                            }
                            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                            optionText="nameBg"
                            label="Държава"
                            validate={!isForeigner && !isMgu ? required("Задължително") : null}
                            readOnly={isDisable}
                            fullWidth
                          />
                        </ReferenceInput>
                      </Grid>
                      {formData.correspondenceCountryId === defaultBirthCountry ? (
                        <Grid
                          item
                          xs={12}
                          lg={6}
                        >
                          <ReferenceInput
                            reference={administrationRequests.getSettlementsSelect()}
                            source="correspondenceSettlementId"
                            filter={{ showDistrictAndMunicipality: true, showPostalCode: true }}
                          >
                            <AutocompleteInput
                              disabled={same}
                              defaultValue={
                                same ? formData.residenceSettlementId : userData?.correspondenceSettlementId
                              }
                              onChange={e => setCorrespondenceSettlementId(e)}
                              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                              optionText="nameBg"
                              optionValue="id"
                              label="Населено място"
                              validate={!isMgu && !isForeigner ? required("Задължително") : null}
                              readOnly={isDisable}
                              fullWidth
                            />
                          </ReferenceInput>
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={12}
                          lg={6}
                        >
                          <TextInput
                            defaultValue={same ? formData.residenceSettlement : userData?.correspondenceSettlement}
                            disabled={same}
                            readOnly={isDisable}
                            label="Населено място"
                            source="correspondenceSettlement"
                          />
                        </Grid>
                      )}
                    </>
                  )}
                </FormDataConsumer>

                <>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                  >
                    <TextInput
                      disabled={same}
                      defaultValue={same ? formData.residenceAddress : userData?.correspondenceAddress}
                      source="correspondenceAddress"
                      label="Квартал / Улица"
                      validate={!isForeigner && !isMgu ? required("Задължително") : null}
                      readOnly={isDisable}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                  >
                    <TextInput
                      disabled={same}
                      defaultValue={same ? formData.residencePostalCode : userData?.correspondencePostalCode}
                      source="correspondencePostalCode"
                      label="Пощенски код"
                      validate={!isForeigner && !isMgu ? [required("Задължително"), maxLength(10)] : maxLength(10)}
                      readOnly={isDisable}
                    />
                  </Grid>
                </>

                {!isForeigner ? (
                  <Grid
                    item
                    xs={12}
                    sx={{ marginTop: "-1rem" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={same}
                          disabled={isDisable}
                          onChange={e => {
                            setSame(!same);
                          }}
                        />
                      }
                      label={<span style={{ fontWeight: "bold", fontSize: "16px" }}>Същия като постоянния</span>}
                    />
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </Grid>
  );
};
export default AddressSection;
